import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'common/components/elements/buttons/primary';
import Icon from 'common/components/elements/icons';
import DateFormatter from 'common/utils/DateFormatter';
import generateTextColor from 'common/utils/generateTextColor';
import { useSelector } from 'react-redux';
import { isAgeVerificationRequiredSelector, isNeedFilterBadWordsSelector, isTranslateContentSelector } from 'sites/state/modules/common/selectors';
import { filterBadWords } from 'common/utils/filter-bad-words';
import classNames from 'classnames';

const PromotionNotification = ({
   promotion,
   onClose,
   onClickGetThisDeal,
   screenWidth,
}) => {
   const isMobile = screenWidth <= 1024
   const [isInited, setIsInited] = useState(false)
   const [expireDate, setExpireDate] = useState(DateFormatter.getDateLeftInDays(promotion.expiration_date, true))
   let intervalRef = useRef(null)
   const notificationRef = useRef(null)

   const isAgeVerificationRequired = useSelector(isAgeVerificationRequiredSelector)
   const isNeedFilterBadWords = useSelector(isNeedFilterBadWordsSelector)
   const isTranslateContent = useSelector(isTranslateContentSelector)

   let header = null
   let layoutContent = null
   let signInOrUp = null
   let signUpEmail = null
   let promo = null
   let promoHeight = useRef(0)
   let chatModal = null
   let navbarWrapper = null;
   let notificationsModal = null
   const initHeader = () => {
      header = document.querySelector('.page__header');
      layoutContent = document.querySelector('.layout-content');
      signInOrUp = document.querySelector('.sign_in_or_sign_up')
      signUpEmail = document.querySelector('.sign_up_email_wrapper')
      promo = document.querySelector('#promo')
      chatModal = document.querySelector('#member_chat_modal')
      navbarWrapper = document.querySelector('.navigation-element')
      notificationsModal = document.querySelector('#member_notifications_modal')
   }
   const syncLayout = () => {
      if(!header || !notificationRef) {
         return;
      }
      if(layoutContent) {
         layoutContent.style.paddingTop = `${ header.offsetHeight }px`
      }
      promo.style.top = `-${ notificationRef.current.offsetHeight }px`
      setIsInited(true)
   }

   const openNotification = () => {
      if(!header || !notificationRef?.current) {
         return;
      }
      header.style.top = `${ notificationRef.current.offsetHeight }px`
      header.style.transition = 'top .5s ease-in 0s'

      promo.style.top = `0px`
      promo.style.transition = `top .5s ease-in 0s`
      if(layoutContent) {
         layoutContent.style.paddingTop = `${ notificationRef.current.offsetHeight + header.offsetHeight }px`
         layoutContent.style.transition = `padding-top .5s ease-in 0s`
      }
      if(signInOrUp) {
         signInOrUp.style.paddingTop = !isMobile ? `${ notificationRef.current.offsetHeight + header.offsetHeight + 100 }px` : `${ notificationRef.current.offsetHeight + header.offsetHeight }px`
         signInOrUp.style.transition = `padding-top .5s ease-in 0s`
      }
      if(signUpEmail) {
         signUpEmail.style.paddingTop = `${ notificationRef.current.offsetHeight + header.offsetHeight }px`
         signUpEmail.style.transition = `padding-top .5s ease-in 0s`
      }
      if(chatModal) {
         chatModal.style.top = `${ notificationRef.current.offsetHeight }px`
         chatModal.style.transition = `top .5s ease-in 0s, height .5s ease-in 0s`
         chatModal.style.height = `calc(100% - ${ notificationRef.current.offsetHeight }px)`
      }
      if(navbarWrapper) {
         navbarWrapper.style.marginTop = `${ notificationRef.current.offsetHeight }px`
         navbarWrapper.style.transition = `margin-top .5s ease-in 0s, height .5s ease-in 0s`
         navbarWrapper.style.height = `calc(100% - ${ notificationRef.current.offsetHeight }px)`
      }
      if(notificationsModal) {
         notificationsModal.style.top = `${ notificationRef.current.offsetHeight }px`
         notificationsModal.style.transition = `top .5s ease-in 0s, height .5s ease-in 0s`
         notificationsModal.style.height = `calc(100vh - ${ notificationRef.current.offsetHeight }px)`
      }
   }
   const resetStyles = () => {
      if(!header) {
         return
      }
      if(layoutContent) {
         console.log(header.offsetHeight);
         layoutContent.style.paddingTop = `56px`
      }
      promo.style.top = `-${ promoHeight }px`
      header.style.top = `0px`
      if(chatModal) {
         chatModal.style.top = `0`
         chatModal.style.height = `100%`
      }
      if(navbarWrapper) {
         navbarWrapper.style.marginTop = `0px`
         navbarWrapper.style.height = `100%`
      }
      if(notificationsModal) {
         notificationsModal.style.top = `0`
         notificationsModal.style.height = `100vh`
      }
      resetTransitions()
   }

   const resetTransitions = () => {
      header.style.transition = 'top 0s'
      promo.style.transition = 'top 0s'
      if(layoutContent){
         layoutContent.style.transition = `padding-top 0s`
      }
      if(signInOrUp){
         signInOrUp.style.transition = `padding-top 0s`
      }
      if(signUpEmail) {
         signUpEmail.style.transition = `padding-top 0s`
      }
      if(chatModal) {
         chatModal.style.transition = `top 0s, height 0s`
      }
      if(navbarWrapper) {
         navbarWrapper.style.transition = `margin-top 0s, height 0s`
      }
      if(notificationsModal) {
         notificationsModal.style.transition = `top 0s, height 0s`
      }
   }

   const handleResizeScreen = () => {
      if(!header || !notificationRef?.current) {
         return;
      }
      resetTransitions()
      if(layoutContent) {
         layoutContent.style.paddingTop = `${ header.offsetHeight + notificationRef.current.offsetHeight }px`
      }
      if(signInOrUp){
         signInOrUp.style.paddingTop = !isMobile ? `${ notificationRef.current.offsetHeight + header.offsetHeight + 100 }px` : `${ notificationRef.current.offsetHeight + header.offsetHeight }px`
      }
      if(signUpEmail) {
         signUpEmail.style.paddingTop = `${ notificationRef.current.offsetHeight + header.offsetHeight }px`
      }
      if(chatModal) {
         chatModal.style.top = `${ notificationRef.current.offsetHeight }px`
         chatModal.style.height = `calc(100% - ${ notificationRef.current.offsetHeight }px)`
      }
      if(navbarWrapper) {
         navbarWrapper.style.marginTop = `${ notificationRef.current.offsetHeight }px`
         navbarWrapper.style.height = `calc(100% - ${ notificationRef.current.offsetHeight }px)`
      }
      if(notificationsModal) {
         notificationsModal.style.top = `${ notificationRef.current.offsetHeight }px`
         notificationsModal.style.height = `calc(100vh - ${ notificationRef.current.offsetHeight }px)`
      }
      header.style.top = `${ notificationRef.current.offsetHeight }px`
   }

   useEffect(() => {
      initHeader()
      if(!isInited) {
         syncLayout()
      }
      if(!isInited) {
         setTimeout(() => {
            openNotification()
         }, 3000)
      } else {
         openNotification()
      }

      return () => {
         resetStyles()
      }

      // eslint-disable-next-line
   }, [])

   useEffect(() => {
      if(isInited) {
         initHeader()
         promoHeight.current = promo.offsetHeight
         handleResizeScreen()
      }

      // eslint-disable-next-line
   }, [screenWidth])

   useEffect(() => {
      if(!promotion.expiration_date || !promotion.show_public_countdown) return;

      intervalRef.current = setInterval(() => {
         setExpireDate(DateFormatter.getDateLeftInDays(promotion.expiration_date, true))
      }, 1000)

      return () => {
         if(intervalRef.current) {
            clearInterval(intervalRef.current)
         }
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [promotion.expiration_date])

   const getPromotionInfoComponent = () => {
      let spotsCount;
      switch (true) {
         case !promotion.show_public_countdown && !promotion.show_public_limit_countdown:
            return null;

         case (promotion.usage_limit === 'limited' && promotion.show_public_limit_countdown && promotion.show_public_countdown):
            spotsCount = promotion.count_of_limited_usage - promotion.count_of_current_usage;
            return (
               <>
                  : <span className='font-semibold'>
                     Ends in { expireDate } or{spotsCount === 1 ? '' : ' all'} { spotsCount } {spotsCount === 1 ? 'spot is' : 'spots are'} sold!
                  </span>
               </>
            )

         case ((promotion.usage_limit === 'limited' && !promotion.show_public_limit_countdown && promotion.show_public_countdown) || (promotion.usage_limit !== 'limited' && promotion.show_public_countdown)):
            return (
               <>
                  : <span className='font-semibold'>
                     Ends in { expireDate }!
                  </span>
               </>
            )

         case (promotion.usage_limit === 'limited' && promotion.show_public_limit_countdown && !promotion.show_public_countdown):
            spotsCount = promotion.count_of_limited_usage - promotion.count_of_current_usage;
            return (
               <>
                  : <span className='font-semibold'>
                     Ends when{spotsCount === 1 ? '' : ' all'} { spotsCount } {spotsCount === 1 ? 'spot is' : 'spots are'} sold!
                  </span>
               </>
            )

         default:
            return null;
      }
   }


   const generatedColor = generateTextColor.adaptColor(window.skinPrimaryColor)

   return (
      <div
         className={ cx({
            'relative min-h-14 pl-4 flex justify-center gap-6 w-full skin-primary-background': true,
            'py-2.5 pr-16 items-center': !isMobile,
            'py-3 pr-4 flex-col gap-4 items-start': isMobile,
         }) }
         ref={ notificationRef }
      >
         <div
            className='flex gap-4 items-center'
            style={ {
               maxWidth: isMobile ? '90%' : '',
            } }
         >
            <Icon
               name='hero-section'
               color={ generatedColor }
               darkColor={ generatedColor }
               size='xl'
            />
            <span className={ `text-xl leading-6 flex-1 text-${ generatedColor }` }>
               <span
                  // notranslate-content-title
                  className={ classNames({
                     'font-semibold': true,
                     'notranslate': !isTranslateContent,
                  }) }
               > { isAgeVerificationRequired || isNeedFilterBadWords ? filterBadWords(promotion.name) : promotion.name } </span>
               { promotion.discount_percentage }% off { promotion.discount_type === 'all_payments' ? 'all payments' : 'first payment' }
               {getPromotionInfoComponent()}
            </span>
         </div>
         <div
            className={ cx({
               'h-9': true,
               'w-full': isMobile,
            }) }
         >
            <Button
               text='Get this deal'
               classNames='h-full px-1.5 group'
               textClassName='whitespace-nowrap group-hover:underline'
               borderRadius='large'
               padding='none'
               textSize='small'
               alignment='center'
               onClick={ onClickGetThisDeal }
               backgroundColor='panel dark:bg-panel-dark'
               textColor='major dark:text-major-dark'
            />
         </div>

         <div
            className={ cx({
               'absolute w-6 h-6 [@media(max-width:701px)]:bottom-[18px]': true,
               'top-4 right-6': !isMobile,
               'top-3 right-4': isMobile,
            }) }
         >
            <Button
               iconName='close'
               classNames={ `w-full h-full text-${ generatedColor }` }
               alignment='center'
               backgroundColor='transparent'
               fontIconColor={ generatedColor }
               darkIconColor={ generatedColor }
               waveActive={ false }
               onClick={ onClose }
            />
         </div>
      </div>
   )
}

PromotionNotification.propTypes = {
   promotion: PropTypes.object,
   onClose: PropTypes.func,
   onClickGetThisDeal: PropTypes.func,
   screenWidth: PropTypes.number,
}

export default PromotionNotification
